import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { canadianProvinces } from "../../utils/countryOptions";
import moment from "moment";
import { useAuth } from "../../context/AuthContext";
import { fcwdOnly, setFcwdOnly } from "../../utils/data";
import { formatDOB, validateDate } from "../../components/consts/dateMask"

function QueryCA() {
  const {source, token, userState, email, roles} = useAuth();
  const [providence, setProvidence] = useState('');
  const [licenseNumber, setLicenseNumber] = useState('');
  const [lastName, setLastName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [validated, setValidated] = useState(false);

  const [ dateErr, setDateErr ] = useState([])
  const navigate = useNavigate();

  let ny = ""
  const handleSetDob = () => {
     let dp = new Date().toISOString().split('T')[0];
    const [y,m,d] = dp.split('-');
    const yn = y - 21;
    ny = yn+'-'+m+'-'+d; 
    setDob(ny)
  }

  const [dob, setDob] = useState(ny)

  const defined = (v) => v !== undefined && v !== null && v !== "";

  const disableKey  = (event) =>{ 
        event.preventDefault();
        const { name, value } = event.target;
        if(formatDOB(value)){
            return;
        }
  }

   const cleanDate = (d) => {
        if(d === undefined){
            return;
        }
        if(d.includes("-")){
            return d.replace(/-/g, ""); 
        }
    }
/*
   const cleanDate = (d) => {
        if(d === undefined){
            return;
        }
        if(d.includes("-")){
            return d.replace(/-/g, ""); 
        }
    }
/*
  const convertDate = (d) =>{
        if (!defined(d)) return undefined;
        // If already "YYYYMMDD", return as-is:
        if (typeof d === "string" && /^\d{8}$/.test(d)) return d;
        try {
            const dt = new Date(d);
            const y = dt.getFullYear();
            const m = String(dt.getMonth() + 1).padStart(2, "0");
            const day = String(dt.getDate()).padStart(2, "0");
            return `${y}${m}${day}`;
        } catch {
            return undefined;
        }
  };
*/
    const handleLicChange = (e) => {
    const v = e.target.value;

    if(providence === 'MB'){
      const pattern =  new RegExp("^[a-zA-Z0-9-*]*$");
      if(pattern.test(v)){
        setLicenseNumber(v.toUpperCase());
      }
    }
    const pattern =  new RegExp("^[a-zA-Z0-9-*]*$");
    if(pattern.test(v)){
      setLicenseNumber(v.toUpperCase());
    }
  }   
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
      setDateErr("");
      let val = [];
      //validateDate(dob,true, val)
      //validateDate(dob,true, val)

      console.log(val)
    const form = e.target;
    if (form.checkValidity() === false) {
        e.stopPropagation(); // prevent submit if invalid
    } else {
      let returnedRecord = false;  
        if(val.length > 0){
          setDateErr(val);
          return;
        }

      e.preventDefault();
      let endpoint = `canadadetails/${providence.trim()}/${encodeURIComponent(licenseNumber.trim())}/${lastName.trim()}`;
      if (firstName.trim()) {
          endpoint += `/${firstName.trim()}`;
      }
      //const dob2 = convertDate(dob)
      const DOB = cleanDate(dob);
      endpoint += `/${DOB}`;

      console.log("EP: "+endpoint)
      if(e.nativeEvent.submitter.value === 'fcwdOnly'){
        console.log('FCWD ONLY button clicked');
        setFcwdOnly(true);
      } else{
        setFcwdOnly(false);
      }
      navigate(endpoint);
    }
    setValidated(true);
  }

  return (
    <div className="App">
      <h1>Query Canada</h1>
      <div>
        <div style={{color: "red"}}>{dateErr}</div>
      <form className={`needs-validation ${validated ? "was-validated" : ""}`} id="Index-form" style={{textAlign: 'left'}} noValidate onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-5">
            <label className="form-label"><b><span className="text-danger">*</span> Province:</b></label>
            <select className="form-control form-select" aria-label=".form-select-lg example"
              required     
              value={providence}
              onChange={(e) => setProvidence(e.target.value)}
            >
              <option value= "" disabled> -- select an option -- </option>
              {canadianProvinces.map((opt) => (
                <option key={opt.code} value={opt.code}>
                  {opt.label}
                </option>
              ))}
            </select>
            <div className="invalid-feedback">Providence Required</div>
          </div>
          <div className="col-md-4">
            <label className="form-label"><b><span className="text-danger">*</span> Driver License Number:</b></label>
            <input
              type="text"
              className="form-control text-uppercase"
              placeholder="Enter Driver License Number"
              name="LicenseNumber"
              value={licenseNumber}
              onChange={(e) => setLicenseNumber(e.target.value.toUpperCase())}
              required
            />
            <div className="invalid-feedback">Driver License Number Required</div>
          </div>
        </div>
        <div className="row">
        <div className="col-md-6">
            <label for="inputLastName" className="form-label"><b><span className="text-danger">*</span> Last Name</b></label>
            <input className="form-control" type="text" name='DriverLastName' 
            onChange={(e) => setLastName(e.target.value)} required/>
            <div className="invalid-feedback">Last Name Required</div>
            
        </div>
          <div className="col-md-3">
              <label for="inputFirstName" className="form-label"><b>First Name</b></label>
              <input type="text" className="form-control" name="DriverFirstName"
              onChange={(e) => setFirstName(e.target.value)}/>
          </div>
           <div className="col-md-2">
              <label for="inputDOB" className="form-label"><b><span className="text-danger">*</span> Date of Birth</b></label>
              
                  <input type="date" className="form-control" 
                      placeholder="MM/DD/YYYY"
                      data-index="1"  name='dob'
                      value={dob}
                      onChange={(e) => setDob(e.target.value)}
                      min="1"
                      onClick={handleSetDob}
                      max={moment().format("YYYYMMDD")}
                      onKeyDown={(e) => disableKey(e)}
                      pattern='(0[1-9]|1[1,2])(\/|-)(0[1-9]|[12][0-9]|3[01])(\/|-)(19|20)\d{2}' 
                    required />
            


              <div className="invalid-feedback">Please enter a valid Date of Birth</div>
          </div>
          <small>*First Name is required to match the Canadian Record. If the driver has only one name or a period(.) as a first name, the field may be left blank.</small>
          
      </div>
      {source === 'HelpDesk' ?
            <><button type="submit" className="btn btn-primary" id="button" form='Index-form' style={{ marginTop: '32px' }}>Search Canada</button>
            <button type="submit" className="btn btn-primary" id="button" value={'fcwdOnly'} form='Index-form' style={{ marginTop: '32px' }}>Search FCWD ONLY</button></>
              :
              <button type="submit" className="btn btn-primary" id="button" form='Index-form' style={{alignContent:'end'}}>Submit Driver Query</button>
        }
      </form>
      </div>
      </div>
  );
}
export default QueryCA;